/* eslint-disable import/no-anonymous-default-export */

export default {
  INIT: 'APP/INIT',
  UPDATE_LANG: 'APP/UPDATE_LANG',
  UPDATE_ADLASTPOPDATE: 'APP/UPDATE_ADLASTPOPDATE',
  POP_AD: 'APP/POP_AD',
  CLOSE_AD: 'APP/CLOSE_AD',
  UPDATE_IP_INFO: 'APP/UPDATE_IP_INFO',
}
